export default {
  videoAllowType: ['mp4', 'webm', 'ogg'],
  audioAllowType: ['mp3'],
  page_name: {
    operation_page: 'operation_page',
    video_detail_page: 'video_detail_page',
    live_detail_page: 'live_detail_page',
    live_subscribe_page: 'live_subscribe_page',
    article_detail_page: 'article_detail_page',
    atlas_detail_page: 'atlas_detail_page',
    summary_detail_page: 'summary_detail_page',
    search_page: 'search_page',
    audio_detail_page: 'audio_detail_page'
  },
  share_type: {
    wechat: 'wechat',
    moments: 'moments',
    sina: 'sina',
    twitter: 'twitter',
    facebook: 'facebook'
  },
  bhv_type: {
    expose: 'expose',
    click: 'click',
    stay: 'stay',
    facebook: 'facebook'
  },
  component_type: {
    '1': 'expose',
    click: 'click',
    stay: 'stay',
    facebook: 'facebook'
  },
  live_type: {
    live_subscribe: 'live_subscribe',
    live_running: 'live_running',
    live_back: 'live_back'
  },
  live_type_change: {
    wait: 'live_subscribe',
    running: 'live_running',
    end: 'live_back'
  },
  summary_type: {
    normal_subject: 'normal_subject',
    thematic_subject: 'thematic_subject',
    author_subject: 'author_subject'
  },
  item_type: {
    article: 'article',
    image: 'image',
    item: 'item',
    video: 'video',
    live: 'live',
    audio: 'audio'
  },
  item_id: {
    _article: '_article',
    _image: '_image',
    _item: '_item',
    _video: '_video',
    _audio: '_audio'
  },
  content_type: {
    '0': '0',
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '10': '10',
    '11': '11',
    '12': '12',
    '13': '13'
  },
  content_style: {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '10': '10'
  },
  allChannels: [
    {
      channelAlias: 'topnews',
      channelId: 1001,
      channelName: 'Top News',
      channelStrategy: 1,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'xijinping',
      channelId: 1002,
      channelName: 'XI JINPING',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'trending',
      channelId: 1003,
      channelName: 'TRENDING',
      channelStrategy: 1,
      channelStyle: 1,
      pcStyle: ''
    },
    {
      channelAlias: 'pd-series',
      channelId: 1004,
      channelName: 'PD SERIES',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'live',
      channelId: 1008,
      channelName: 'LIVE',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'pd-studio',
      channelId: 1005,
      channelName: 'PD Studio',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'pd-talk',
      channelId: 1006,
      channelName: 'PD Talk',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'pd-cafe',
      channelId: 1007,
      channelName: 'PD Café',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'bri-news',
      channelId: 1009,
      channelName: 'BRI NEWS',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'brnn',
      channelId: 1010,
      channelName: 'BRNN',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'bri video',
      channelId: 2076,
      channelName: 'BRI VIDEO',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'about-brnn',
      channelId: 1011,
      channelName: 'About BRNN',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'updates',
      channelId: 1012,
      channelName: 'UPDATES',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'projects',
      channelId: 1013,
      channelName: 'PROJECTS',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'research',
      channelId: 1014,
      channelName: 'RESEARCH',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'data',
      channelId: 1015,
      channelName: 'DATA',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'documents',
      channelId: 1016,
      channelName: 'DOCUMENTS',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'speeches',
      channelId: 1017,
      channelName: 'SPEECHES',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'countries',
      channelId: 1018,
      channelName: 'COUNTRIES',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'bri-abc',
      channelId: 1019,
      channelName: 'BRI ABC',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'members',
      channelId: 1033,
      channelName: 'Members',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'timeline',
      channelId: 1032,
      channelName: 'Timeline',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'charter',
      channelId: 1031,
      channelName: 'Charter',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'headline',
      channelId: 1030,
      channelName: 'HEADLINE',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'section',
      channelId: 1020,
      channelName: 'SECTION',
      channelStrategy: null,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'sports',
      channelId: 1021,
      channelName: 'SPORTS',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'business',
      channelId: 1022,
      channelName: 'BUSINESS',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'opinions',
      channelId: 1023,
      channelName: 'OPINIONS',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'culture',
      channelId: 1024,
      channelName: 'CULTURE',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'photos',
      channelId: 1025,
      channelName: 'PHOTOS',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'tech',
      channelId: 1026,
      channelName: 'TECH',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'china',
      channelId: 1027,
      channelName: 'CHINA',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'world',
      channelId: 1028,
      channelName: 'WORLD',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    },
    {
      channelAlias: 'travel',
      channelId: 1029,
      channelName: 'TRAVEL',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: ''
    }
  ],
  topChannels: [
    {
      channelAlias: 'HOME',
      channelId: -1,
      channelName: 'HOME',
      channelStrategy: null,
      channelStyle: null,
      pcStyle: ''
    },
    {
      channelAlias: 'china',
      channelId: 1027,
      channelName: 'CHINA',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: '1'
    },
    {
      channelAlias: 'world',
      channelId: 1028,
      channelName: 'WORLD',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: '1'
    },
    {
      channelAlias: 'business',
      channelId: 1022,
      channelName: 'BUSINESS',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: '1'
    },
    {
      channelAlias: 'opinions',
      channelId: 1023,
      channelName: 'OPINIONS',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: '1'
    },
    {
      channelAlias: 'culture',
      channelId: 1024,
      channelName: 'CULTURE',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: '1'
    },
    {
      channelAlias: 'sports',
      channelId: 1021,
      channelName: 'SPORTS',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: '1'
    },
    {
      channelAlias: 'photos',
      channelId: 1025,
      channelName: 'PHOTOS',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: '1'
    },
    {
      channelAlias: 'tech',
      channelId: 1026,
      channelName: 'TECH',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: '1'
    },
    {
      channelAlias: 'travel',
      channelId: 1029,
      channelName: 'TRAVEL',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: '1'
    },
    {
      channelAlias: 'trending',
      channelId: 1003,
      channelName: 'TRENDING',
      channelStrategy: 1,
      channelStyle: 1,
      pcStyle: '2'
    },
    {
      channelAlias: 'pd-series',
      channelId: 1004,
      channelName: 'PD SERIES',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: '4'
    },
    {
      channelAlias: 'live',
      channelId: 1008,
      channelName: 'LIVE',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: '2'
    },
    {
      channelAlias: 'bri-news',
      channelId: 1009,
      channelName: 'BRI NEWS',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: '1'
    },
    {
      channelAlias: 'brnn',
      channelId: 1010,
      channelName: 'BRNN',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: '5'
    }
  ],
  bottomChannels: [
    {
      channelAlias: 'sports',
      channelId: 1021,
      channelName: 'SPORTS',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: '1'
    },
    {
      channelAlias: 'business',
      channelId: 1022,
      channelName: 'BUSINESS',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: '1'
    },
    {
      channelAlias: 'trending',
      channelId: 1003,
      channelName: 'TRENDING',
      channelStrategy: 1,
      channelStyle: 1,
      pcStyle: '2'
    },
    {
      channelAlias: 'bri-news',
      channelId: 1009,
      channelName: 'BRI NEWS',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: '1'
    },
    {
      channelAlias: 'opinions',
      channelId: 1023,
      channelName: 'OPINIONS',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: '1'
    },
    {
      channelAlias: 'pd-series',
      channelId: 1004,
      channelName: 'PD SERIES',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: '4'
    },
    {
      channelAlias: 'culture',
      channelId: 1024,
      channelName: 'CULTURE',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: '1'
    },
    {
      channelAlias: 'photos',
      channelId: 1025,
      channelName: 'PHOTOS',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: '1'
    },
    {
      channelAlias: 'tech',
      channelId: 1026,
      channelName: 'TECH',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: '1'
    },
    {
      channelAlias: 'china',
      channelId: 1027,
      channelName: 'CHINA',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: '1'
    },
    {
      channelAlias: 'world',
      channelId: 1028,
      channelName: 'WORLD',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: '1'
    },
    {
      channelAlias: 'travel',
      channelId: 1029,
      channelName: 'TRAVEL',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: '1'
    },
    {
      channelAlias: 'live',
      channelId: 1008,
      channelName: 'LIVE',
      channelStrategy: 2,
      channelStyle: 2,
      pcStyle: '2'
    }
  ]
}
